import { RoutesInside } from "@general-backoffice/core";
import React from "react";

import Auth from "./Auth";

const Legal: React.FC = () => {
  return (
    <Auth>
      <div style={{ paddingTop: 150 }}>
        <RoutesInside />
      </div>
    </Auth>
  );
};

export default Legal;
